import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SuperSEO } from "react-super-seo";
import PsContext from "../../context";
import { DB_POSTFIX, LOADER_LOGO, momentDate, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const ViewEvent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataAllList, setAllList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const [yearsList, setYearsList] = useState([]);

  useEffect(() => {
    loadData();
    listData();
  }, [props.match.params]);

  const loadData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.GET_PAGE +
          "?sadb=" +
          DB_POSTFIX +
          "&type=event&id=" +
          props.match.params.id
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });

    axios
      .get(ServiceUrl.LIST_EVENT_YEARS + "?sadb=" + DB_POSTFIX + "&type=event")
      .then((res) => {
        if (res["data"].status == "1") {
          setYearsList(res["data"].data);
        }
        setLoader(false);
      });
  };

  const listData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?sadb=" +
          DB_POSTFIX +
          "&type=event&id=" +
          props.match.params.id
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setAllList(res["data"].data);
          console.log("ttt", res["data"].data);
        }
        setLoader(false);
      });
  };

  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}

      {!loader && dataList.id && (
        <>
          <SuperSEO title={"Events " + field("title")} lang="en" />

          <section>
            <div className="container com-sp pad-bot-70 pg-inn ps_min_height px-5">
              <h5
                style={{
                  color: `${context.settingValue("web_site_header_textcolor")}`,
                }}
              >
                <i class="fa-solid fa-angles-right me-2"></i>
                {upperCase(field("title"))}
              </h5>
              <hr />
              {/*<span>{momentDate(field("active_from_date"), "DD")} </span>
                <span>{momentDate(field("active_from_date"), "MMM,YYYY")}</span>*/}
              <Row>
                <Col md={8}>
                  <div className="">
                    <div style={{ fontSize: "14px" }} className="mb-2">
                      {momentDate(field("active_from_date"))}
                    </div>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: field("content_html"),
                      }}
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <Link
                    to="/events/completed"
                    className="btn btn-outline-secondary text-center w-100"
                  >
                    View All Events
                  </Link>
                </Col>
              </Row>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default ViewEvent;
